






















import {
  computed,
  defineComponent,
  getCurrentInstance,
  ref,
  PropType,
} from '@vue/composition-api'
import dayjs from 'dayjs'

import ExportButton from '@/components/molecules/h/ExportButton.vue'
import ExtractCondition from '@/components/organisms/h/page/new-store-bulk-order/new-store-bulk-order-sheet/ExtractCondition.vue'
import TitleAndManipulate from '@/components/organisms/h/TitleAndManipulate.vue'
import {
  outputCondUseInfoList,
  NewStoreBulkOrderSheetExtractCondition,
} from '@/types/entities'
import { today } from '@/utils/mixin'
export default defineComponent({
  components: {
    TitleAndManipulate,
    ExtractCondition,
    ExportButton,
  },
  props: {
 
    outputUseList: {
      type: Array as PropType<outputCondUseInfoList>,
      default: () => [],
    },
    isDisable: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    exportSpinner: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    defaultDateValue: {
      type: String as PropType<string>,
      default: () => '',
    }
  },
  setup(props, context) {
    const instance = getCurrentInstance()
    if (!instance) {
      // should be called in setup
      return
    }
    const { $i18n } = instance.proxy

    const requestExport = () => {
      context.emit('request-export')
    }
    const requestImport = () => {
      context.emit('request-import')
    }
    const changeExtractCondition = (cond: NewStoreBulkOrderSheetExtractCondition) => {
      // console.log('changeExtractCondition', { cond })
      context.emit('change-extract-condition', cond)
    }

    const changeOutputCondition = (
      cond: NewStoreBulkOrderSheetExtractCondition) => {
      context.emit('change-output-condition', cond)
    }

    return {
      requestExport,
      requestImport,
      changeExtractCondition,
      changeOutputCondition,
    }
  },
})
